module.exports = __webpack_public_path__ + "media/images/warning-29fee95d5b89f1b3642e44a07e5af062.svg";